import { deleteCookie, getCookie, setCookie } from "../utils/Cookies"

/** Must match Banner::CLICK_PARAM. */
const CLICK_PARAM = 'banner'
const CLICK_COOKIE = 'CatalogBannerClick'
const CLICK_COOKIE_DAYS = 7

const bannerPayload = (el: HTMLElement) => {
    const { bannerVariant, bannerModel, bannerPrice, bannerCount, bannerUrl } = el.dataset

    return {
        bannerVariant: bannerVariant ?? '',
        pageUrl: window.location.href,
        targetUrl: bannerUrl ?? '',
        model: bannerModel ?? '',
        price: bannerPrice ?? '',
        ...(bannerCount !== undefined ? { offersCount: parseInt(bannerCount) } : {}),
    }
}

export const CatalogBanner = {
    'x-intersect.once.threshold.50'() {
        window.dataLayer?.push({ event: 'Zobrazení banneru v katalogu', ...bannerPayload(this.$el) })
    },
    '@click'(ev: MouseEvent) {
        if (!(ev.target as HTMLElement).closest('.CatalogBanner-button')) return

        setCookie(CLICK_COOKIE, this.$el.dataset.bannerVariant ?? '1', CLICK_COOKIE_DAYS)
        window.dataLayer?.push({ event: 'Proklik banneru v katalogu', ...bannerPayload(this.$el) })
    },
}

/** Landing page of a banner link: remember the click, then drop the marker from the URL. */
export const rememberBannerLanding = () => {
    const url = new URL(window.location.href),
        variant = url.searchParams.get(CLICK_PARAM)
    if (!variant) return

    setCookie(CLICK_COOKIE, variant, CLICK_COOKIE_DAYS)
    url.searchParams.delete(CLICK_PARAM)
    history.replaceState(history.state, '', url.toString())
}

/** Attribution fields for the form-send dataLayer event; a remembered click is spent on the first submit. */
export const consumeBannerClick = () => {
    const variant = getCookie(CLICK_COOKIE)
    if (!variant) return {}

    deleteCookie(CLICK_COOKIE, '/')

    return { bannerClicked: true, bannerVariant: variant }
}
